// eslint-disable-next-line no-shadow
export enum AssetsPermissions {
  MANAGE_ASSET = 'admin.coursebuilder.asset.manage',
  EDIT_IMAGE_LIBRARY = 'admin.coursebuilder.imagelibrary.edit',
  ACCESS_IMAGE_LIBRARY = 'admin.coursebuilder.imagelibrary.access',
}
